import { Link } from "react-router-dom";
import { IconPencil } from "../../../assets/icons";
import { ButtonAction } from "../../../components";
import { OverflowText } from "../../../helpers";
import { EDITHAMACATEGORY } from "../../../routes/routesNames";

const columns =  [
    {
        name: 'Kategori',
        selector: row => row.name,
        sortable: true,
        maxWidth : "296px",
    },
    {
        name: 'Nama Latin',
        selector: row => row.nama_latin,
        sortable: true,
        maxWidth : "296px",
    },
    {
        name: 'Deskripsi',
        selector: row => row.desc,
        sortable: true,
        maxWidth : "510px",
        format : (row,index) => {
            return <OverflowText text={row.desc ? row.desc : ''} />

        }
    },
    {
        name: 'Tanaman',
        selector: row => row.desc,
        sortable: true,
        format : (row,index) => {
            return <div className="pb-1">
                {
                    row.type_of_plant && row.type_of_plant.map((data,index) => (
                        <span key={index} className="label-info">{data} </span>
                    ))
                }
            </div> 
        }
    },
    {
        name: 'Aksi',
        selector: row => row.name,
        sortable: true,
        maxWidth : "150px",
        format : (row,index) => {
            return <Link to={EDITHAMACATEGORY} state={row}>
                <ButtonAction title="Ubah" icon={IconPencil} />
            </Link> 
        }
    },
];

export default columns;